import ManageDraftContactDrawer from './ManageDraftContactDrawer.component';

export default ManageDraftContactDrawer;
